// extracted by mini-css-extract-plugin
export default {"outer":"empty_outer__XPDON","inner":"empty_inner__yargj","title":"empty_title__3WPUO","content":"empty_content__fLy1O","illustration":"empty_illustration__C1B2d"};